import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const api = axios.create({ baseURL: '/api' });
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default function ProductRegisterBulk() {
  const navigate = useNavigate();
  const [bulkResult, setBulkResult] = useState(null);
  const [bulkLoading, setBulkLoading] = useState(false);

  const handleBulkUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = '';
    setBulkLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const r = await api.post('/products/bulk-upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setBulkResult(r.data.results);
    } catch (e) {
      alert('업로드 실패: ' + (e.response?.data?.message || e.message));
    } finally {
      setBulkLoading(false);
    }
  };

  const closeResult = () => {
    setBulkResult(null);
    navigate('/products');
  };

  return (
    <div style={{ minWidth: '600px', maxWidth: '600px' }}>
      <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '20px' }}>엑셀 일괄등록</h2>

      <div style={{ background: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '12px', padding: '24px' }}>
        <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.7', marginBottom: '20px' }}>
          1. 아래 버튼으로 등록 양식을 다운로드합니다.<br/>
          2. 6행부터 상품 정보를 입력합니다.<br/>
          3. 완성된 파일을 업로드하면 자동으로 등록됩니다.<br/>
          4. 대표이미지/상세이미지는 URL을 입력하면 등록 시 서버로 자동 다운로드됩니다.<br/>
          5. 브랜드/제조사는 텍스트로만 등록되며, 스마트스토어 브랜드 매칭은 등록 후 상품 수정 화면에서 개별적으로 검색해 진행해주세요.<br/>
          6. 고시정보 상세 항목은 카테고리가 매칭되면 판매처 전송 시 자동으로 채워집니다.<br/>
          7. 세제/세정제 등 일부 카테고리는 "생활화학/살생물제 인증" 여부가 기본값(승인/신고대상 아님)으로 자동 처리됩니다. 실제로 인증을 받은 상품이라면 등록 후 상품 수정 화면에서 "승인/신고대상"으로 변경해주세요.
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <a href="/상품일괄등록양식.xlsx" download
            style={{ flex: 1, textAlign: 'center', fontSize: '13px', padding: '12px', borderRadius: '8px', border: '0.5px solid #1D9E75', color: '#1D9E75', cursor: 'pointer', fontWeight: '500', textDecoration: 'none' }}>
            일괄등록양식 다운로드
          </a>
          <label style={{ flex: 1, textAlign: 'center', fontSize: '13px', padding: '12px', borderRadius: '8px', border: '0.5px solid #378ADD', color: '#378ADD', cursor: 'pointer', fontWeight: '500' }}>
            엑셀 파일 업로드
            <input type="file" accept=".xlsx" style={{ display: 'none' }} onChange={handleBulkUpload} />
          </label>
        </div>
      </div>

      {bulkLoading && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px 40px', fontSize: '14px', fontWeight: '500' }}>업로드 중...</div>
        </div>
      )}

      {bulkResult && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '480px', maxHeight: '70vh', display: 'flex', flexDirection: 'column' }}>
            <div style={{ fontSize: '15px', fontWeight: '600', marginBottom: '16px' }}>일괄등록 결과</div>
            <div style={{ flex: 1, overflowY: 'auto', marginBottom: '16px', border: '0.5px solid #e8e8e8', borderRadius: '8px' }}>
              {bulkResult.map((r, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 14px', borderBottom: '0.5px solid #f0f0f0' }}>
                  {r.status === 'success' && <span style={{ fontSize: '12px', color: '#1D9E75', fontWeight: '500', flexShrink: 0 }}>✓ 등록완료</span>}
                  {r.status === 'fail' && <span style={{ fontSize: '12px', color: '#E24B4A', fontWeight: '500', flexShrink: 0 }}>✗ 실패</span>}
                  {r.status === 'duplicate' && <span style={{ fontSize: '12px', color: '#EF9F27', fontWeight: '500', flexShrink: 0 }}>⚠ 중복</span>}
                  <span style={{ fontSize: '12px', color: '#1a1a1a' }}>{r.code}</span>
                  {r.status === 'fail' && <span style={{ fontSize: '11px', color: '#aaa' }}>({r.reason})</span>}
                  {r.status === 'duplicate' && <span style={{ fontSize: '11px', color: '#aaa' }}>(스킵)</span>}
                </div>
              ))}
            </div>
            <div style={{ fontSize: '13px', color: '#444', marginBottom: '16px', padding: '10px 14px', background: '#f5f5f5', borderRadius: '8px' }}>
              총 {bulkResult.length}건 중 등록완료 {bulkResult.filter(r=>r.status==='success').length}건 / 중복 {bulkResult.filter(r=>r.status==='duplicate').length}건 / 실패 {bulkResult.filter(r=>r.status==='fail').length}건
            </div>
            <button onClick={closeResult} style={{ padding: '10px', borderRadius: '8px', border: 'none', background: '#1D9E75', color: '#fff', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>확인 (상품관리로 이동)</button>
          </div>
        </div>
      )}
    </div>
  );
}
